import React from 'react'
import { Spinner, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import PageContext from 'src/apps/Page/libraries/context'
import PageVisualEditor from 'src/apps/Page/pages/VisualEditor'
import { usePage } from 'src/graphql/hooks'

const CustomPageVisualEditor = ({ returnUrl }) => {
   const { pageId } = useParams()
   const { page, loading: pageIsLoading } = usePage({ id: pageId, withContent: true })

   if (pageIsLoading) {
      return (
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            backgroundColor="#222">
            <Spinner width="50px" height="50px" color="#666" />
         </View>
      )
   }

   return (
      <PageContext.Provider value={page}>
         {/* TODO: This returnUrl should not be necessary.
         Will change when VisualEditor is given the overhaul it deserves
         PR #682 */}
         <PageVisualEditor returnUrl={returnUrl} />
      </PageContext.Provider>
   )
}

CustomPageVisualEditor.propTypes = {
   returnUrl: PropTypes.string.isRequired
}

export default CustomPageVisualEditor
